// 학생 신원은 주소의 `?session=` 에 들어 있다. 이 앱은 로그인이 없어서 모든 화면이
// 같은 방식으로 신원을 푼다(student/CLAUDE.md 참고). 여러 컴포넌트가 쓰므로 한 곳에 둔다.
export const readSessionFromUrl = () => {
  const session = new URLSearchParams(window.location.search).get("session");
  if (!session) {
    return null;
  }

  try {
    const [studentId, randomCode] = atob(session).split(":");
    return studentId && randomCode ? { studentId, randomCode } : null;
  } catch (error) {
    return null;
  }
};
